export default "__VITE_ASSET__DYbNSBql__"